import Pagination from '../../../components/Pagination';
import EbookSubmissionListItem, { IPropsEbookSubmissionListItem } from '../components/EbookSubmissionListItem';

interface IPropsEbookSubmissionListTablePresenter {
  currentPage: number;
  pageLimit?: number;
  totalCount?: number;
  ebookSubmissionLists?: IPropsEbookSubmissionListItem[];
  onChangePage: (page: number) => void;
  onCancel: (ebookSubmissionId: string) => void;
}

const PAGE_LIMIT = 10;

const EbookSubmissionListTablePresenter = ({ ebookSubmissionLists, pageLimit, totalCount, currentPage, onChangePage, onCancel }: IPropsEbookSubmissionListTablePresenter) => {
  return (
    <div className="overflow-x-auto overflow-y-hidden">
      <table className="table w-full">
        <thead>
          <tr>
            <th>File name</th>
            <td>Status</td>
            <td>Items</td>
            <td>Uploaded by</td>
            <td>Admin note</td>
            <td>Created at</td>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {ebookSubmissionLists?.map((ebookSubmission) => (
            <EbookSubmissionListItem {...ebookSubmission} key={ebookSubmission._id} onCancel={() => onCancel(ebookSubmission._id)} />
          ))}
        </tbody>
      </table>

      <div className="flex items-center justify-between mt-12">
        <span className="text-systemGrays02LabelSecondary">แสดงผล 10 รายการต่อหน้า</span>

        {(totalCount || 0) > 0 && <Pagination currentPage={currentPage} totalCount={totalCount || 0} pageSize={pageLimit || PAGE_LIMIT} onPageChange={onChangePage} />}
      </div>
    </div>
  );
};

export default EbookSubmissionListTablePresenter;
